<template>
  <div id="allegati-op">
    <link rel="stylesheet"
          :href="dataCdn"/>
    <DPADefaultListGeneral
        :visible="getApiStateTranslations === 3"
        :dataInit="dataInit"
        :set-filters="getFilters"
        :class-div-items="'m-0 p-0'"
        :translations="getDataTranslations"
        name-list="Allegati"
        name-web-component="allegati-op"
    >
      <template v-slot:header>
        <Header />
      </template>
      <template v-slot:header-lite>
        <DPAHeaderLite
            :icon="'fa-regular fa-file-lines'"
            :title="get__('lbl_documents')"
            button
            :href="initialData.urlBtnHeaderLite"
        />
      </template>
      <template v-slot:item-row="{ item, loading }">
        <Row
            :item="item"
            :loading="loading"
        />
      </template>
      <template v-slot:item-lite="{ item, loading }">
        <Row
            :item="item"
            :loading="loading"
        />
      </template>
      <template v-slot:footer>
        <Footer v-if="initialData.useLiteMode"></Footer>
      </template>
    </DPADefaultListGeneral>
  </div>
</template>

<script>
import Vue from "vue";
import createStore from "./store";
import "@digitalpa/component-vue-lib";
import Sand from "@digitalpa/sand-i18n/src/Sand";

Vue.config.productionTip = false
Vue.config.devtools = false
Vue.config.debug = false
Vue.config.silent = true

import { mapGetters, mapActions } from "vuex";

const store =
    typeof createStore === "function" ? createStore({ Vue }) : createStore;

export default {
  name: 'App',
  store,
  components: {
    Row: () => import("@/components/Row.vue"),
    Header: () => import("@/components/Header.vue"),
  },
  data: function(){
    return {
      initialData: false,
      i18n: null,
      searchValue: "",
      sortingValue: [ "publish_date DESC" ],
    }
  },
  props: {
    dataCdn: {
      type: String,
    },
    i18nUrl: {
      type: String,
    },
    i18nSha: {
      type: String,
    },
    dataInit: {
      type: String,
    },
  },
  created: function(){
    this.initialData = JSON.parse(atob(this.dataInit))
  },
  mounted: function(){
    this.i18n = new Sand(this.i18nUrl, this.i18nSha)
    this.$watch(
        vm => [vm.i18n.hasData],
        function() {
          this.setTranslations(this.i18n.getAll());
        },
        {
          immediate: true,
          deep: true
        }
    );
  },
  methods: {
    ...mapActions("translations", [ "setTranslations" ]),
  },
  computed: {
    ...mapGetters("translations", [
      "getDataTranslations",
      "get__",
      "getApiStateTranslations"
    ]),
    getFilters() {
      return {
        ...(this.initialData.filterSorting ? this.getSorting : {}),
      };
    },
    getSorting: function () {
      return {
        sorting: {
          type: "Select",
          value: this.sortingValue,
          onHeader: true,
          onSidebar: false,
          props: {
            // label: this.get__("lbl_sorting"),
            options: [
              {
                id: "publish_date ASC",
                label: this.get__("lbl_data_asc")
              },
              {
                id: "publish_date DESC",
                label: this.get__("lbl_data_desc")
              },
            ],
            clearable: false,
            searchable: true,
            multiple: false
          }
        },
      }
    },
  },
}
</script>
